/**
 * Loại đồng bộ mẫu dự toán
 * nxhinh 04.10.2024
 */
export default {
    Update: 1,
    Replace: 2,
  };
  